import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageConverter from '../../components/ImageConverter';

const ConvertImage: React.FC = () => (
  <ToolLayout
    title="Convert Image Format - PNG, JPG, WebP, BMP | AllTools"
    description="Convert images between PNG, JPG, WebP, BMP, and TIFF formats. Free online image format converter."
    canonicalPath="/convert-image"
  >
    <ImageConverter />
  </ToolLayout>
);

export default ConvertImage;
